import { render, staticRenderFns } from "./Drawprizes.vue?vue&type=template&id=5b5315e2&scoped=true&"
import script from "./Drawprizes.vue?vue&type=script&lang=js&"
export * from "./Drawprizes.vue?vue&type=script&lang=js&"
import style0 from "./Drawprizes.vue?vue&type=style&index=0&id=5b5315e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5315e2",
  null
  
)

export default component.exports